// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_WIKI_REVIEWS_SEARCH = "Vyhled\u00e1v\u00e1n\u00ed v Centru recenz\u00ed";
